import React from "react";
import { withTranslation } from "react-i18next";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import './src/assets/css/style.css';
import homeUseEffect from "./useEffect"

//Sections
import Head from "./src/components/head/Index"
import Main from "./src/components/main/Index";


/**
 * Página institucional
 */

class Index extends React.Component {
  constructor(props) {
    super(props);
    this.state = { codigoReferencia: 'Linkt-sigmobi' };
  }

  componentDidMount() {
    homeUseEffect()
    const { code } = this.props.match.params

    if (code) {
      this.setState({ codigoReferencia: code });
    }

  }


  render() {
    const { codigoReferencia } = this.state
    console.log(codigoReferencia)
    return (

      <React.Fragment>
        <Head />
        <body>
          <Main codigo={codigoReferencia} />
          <script src="./src/assets/js/bootstrap.bundle.min.js" />
        </body>
      </React.Fragment>
    );
  }
}

export default withTranslation()(
  withRouter(
    connect(state => {
      return {};
    }, {})(Index)
  )
);
